import React, {ReactElement} from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {ChatMessage} from 'yougile-model'
import IconClose from './icon-close.svg'

const TwHeader = tw.div`
  flex
  items-center
  justify-between
  pl-16
  pr-8
  font-semibold
  border
  border-t-0
  border-l-0
  border-r-0
  border-solid
  text-18
  bg-main-even-old
  border-lists-divider-old
`

const TwIconClose = tw.div`
  flex
  cursor-pointer
  text-obscure-old
  hover:text-action-hover
  active:text-action-pressed
`

interface Props {
  onSelect: (message: ChatMessage) => void
}

export const Header = ({onSelect}: Props): ReactElement => {
  const close = (): void => {
    onSelect(undefined)
  }
  return (
    <TwHeader>
      <div className="py-8 leading-10">
        {Lang.msg.messageForwarding.forwardMessageToChat}
      </div>
      <TwIconClose onClick={close}>
        <IconClose />
      </TwIconClose>
    </TwHeader>
  )
}
